/**
 * Mobile menu: first click on a parent with children expands the submenu;
 * second click navigates to that page. Chevron toggles open/close.
 */
const NAV_SELECTOR = '.mobile-menu__nav';
const PARENT_LINK_SELECTOR = `${NAV_SELECTOR} .wp-block-navigation-item.has-child > a.wp-block-navigation-item__content`;
const TOGGLE_SELECTOR = `${NAV_SELECTOR} .wp-block-navigation-item.has-child > .wp-block-navigation-submenu__toggle`;

function getToggle(item) {
	return item.querySelector(':scope > .wp-block-navigation-submenu__toggle');
}

function isSubmenuOpen(item) {
	return item.classList.contains('is-submenu-open');
}

function setSubmenuOpen(item, open) {
	const toggle = getToggle(item);
	item.classList.toggle('is-submenu-open', open);
	if (toggle) {
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	}
}

function closeSiblingSubmenus(item) {
	const parent = item.parentElement;
	if (!parent) return;

	parent.querySelectorAll(':scope > .wp-block-navigation-item.has-child').forEach((sibling) => {
		if (sibling !== item) {
			setSubmenuOpen(sibling, false);
		}
	});
}

document.addEventListener(
	'click',
	(event) => {
		const toggle = event.target.closest(TOGGLE_SELECTOR);
		if (toggle) {
			event.preventDefault();
			event.stopImmediatePropagation();
			const item = toggle.closest('.wp-block-navigation-item.has-child');
			if (!item) return;

			const willOpen = !isSubmenuOpen(item);
			if (willOpen) {
				closeSiblingSubmenus(item);
			}
			setSubmenuOpen(item, willOpen);
			return;
		}

		const link = event.target.closest(PARENT_LINK_SELECTOR);
		if (!link) return;

		const item = link.parentElement;
		if (!item || !item.closest(NAV_SELECTOR)) return;

		// Modified clicks (new tab, etc.) — leave alone.
		if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
			return;
		}

		if (isSubmenuOpen(item)) {
			// Second click — go to the parent page.
			event.preventDefault();
			event.stopImmediatePropagation();
			window.location.assign(link.href);
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();
		closeSiblingSubmenus(item);
		setSubmenuOpen(item, true);
	},
	true
);
